///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { accordionFeatureKey, AccordionState } from './accordion.state';
import { CustomerDTO } from '../../../generated/shared-types.model';

export const selectAccordionState = createFeatureSelector<AccordionState>(accordionFeatureKey);

export const selectCustomersList = createSelector(
    selectAccordionState,
    (accordionState: AccordionState): CustomerDTO[] => accordionState.customersList
);

export const selectCurrentCustomerId = createSelector(
    selectAccordionState,
    (accordionState: AccordionState): number => accordionState.selectedCustomerId
);

export const selectCurrentCustomer = createSelector(
    selectAccordionState,
    (accordionState: AccordionState): CustomerDTO => accordionState.currentCustomer
);
